export function tween(alpha, omega, progress) {
    return alpha + ((omega - alpha) * progress)
}
import rgb2hsv from "rgb-hsv"
import hsv2rgb from "hsv-rgb"

import translateColor from "@frog/source/juice/utility/translateColor.js"

export function colortween(a, b, progress, format) {
    const aRGB = translateColor(a).map((num) => num * 255)
    const bRGB = translateColor(b).map((num) => num * 255)
    // const aRGB = [
    //     a >> 16,
    //     a >> 8 & 0xff,
    //     a & 0xff,
    // ]
    // const bRGB = [
    //     b >> 16,
    //     b >> 8 & 0xff,
    //     b & 0xff,
    // ]
    const aHSV = rgb2hsv(...aRGB)
    const bHSV = rgb2hsv(...bRGB)
    const cHSV = [
        tween(aHSV[0], bHSV[0], progress),
        tween(aHSV[1], bHSV[1], progress),
        tween(aHSV[2], bHSV[2], progress),
    ]
    const cRGB = hsv2rgb(...cHSV)

    if(format == "hexstring") {
        return "#" + cRGB.map((value) => value.toString(16).padStart(2, "0")).join("")
    }

    const c = ((1 << 24) + (cRGB[0] << 16) + (cRGB[1] << 8) + cRGB[2] | 0)
    return c
}
